import { TOrderAddressType } from '@features/userPanel/typescript';
import NextCustomerApi from '@features/api/nextApiService/nextCustomerApi';
import { DICTIONARY_TAX_REGIME_TYPE } from '@features/checkout/const';
const useOrderAdditionalData = () => {
  const getInvoiceAddressWithAdditionalData = async (invoiceAddress: TOrderAddressType, type: string) => {
    const {
      additionalData
    } = invoiceAddress;
    if (!additionalData) return invoiceAddress;
    const objFind = additionalData[type] ? additionalData : null;
    if (!objFind) return invoiceAddress;
    switch (type) {
      case 'taxRegime':
        {
          const taxRegimeData = await NextCustomerApi.getDictionaryType(DICTIONARY_TAX_REGIME_TYPE);
          if (!taxRegimeData) return invoiceAddress;
          const [taxRegime] = taxRegimeData.filter(key => key.code === objFind[type]);
          return {
            ...invoiceAddress,
            taxRegime
          };
        }
      default:
        return invoiceAddress;
    }
  };
  return {
    getInvoiceAddressWithAdditionalData
  };
};
export default useOrderAdditionalData;